var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgExpand = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "https://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m14.697 13.28 4.3 4.3v-4.247l2 2v5.663h-5.664l-2-2 4.249-.001-4.3-4.301zm-5.431 0 1.415 1.414-4.3 4.3 4.25.001-2 2H2.965v-5.662l2-2v4.247zM21.01 3.016V8.68l-2 2-.001-4.25-4.301 4.3-1.413-1.414 4.299-4.3h-4.247l2-2zm-12.368 0 2 2H6.395l4.3 4.3L9.28 10.73l-4.3-4.3-.001 4.25-2-2.001V3.015h5.662z"
})));
export default SvgExpand;